"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _aes = require("crypto-es/lib/aes");
var _core = require("crypto-es/lib/core");
var crypto = {
  // Method to encrypt any data. First data will be converted into JSON after that will be encrypted using current host.
  encrypt: function encrypt(data) {
    var encryptKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.host;
    if (data == null) return data;
    if (encryptKey == null) encryptKey = window.location.host;
    return _aes.AES.encrypt(JSON.stringify(data), encryptKey).toString();
  },
  // Method to decrypt any data. First data will be decrypted to bytes after that will be converted to json and parsed back to string.
  decrypt: function decrypt(data) {
    var encryptKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.host;
    if (data == null) return data;
    if (encryptKey == null) encryptKey = window.location.host;
    var bytes = _aes.AES.decrypt(data, encryptKey);
    return JSON.parse(bytes.toString(_core.Utf8));
  }
};
var _default = exports["default"] = crypto;